import * as React from 'react';
import { IColumn } from 'office-ui-fabric-react/lib/DetailsList';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { css } from '@uifabric/utilities/lib/css';
import { IComponentAsProps } from '@uifabric/utilities/lib/IComponentAs';
import { Engagement } from '@ms/telemetry-manager/lib/events/Engagement.event';
import * as ColumnDividerStyles from './ColumnDivider.scss';

export interface IColumnDividerProps {
  column: IColumn;
  columnIndex: number;
  engagement: typeof Engagement;
  addIconVisibleForIndex: number;
  onAddNewColumn: (event: React.MouseEvent<HTMLElement>, column: IColumn, columnIndex: number) => void;
}

export interface IAddColumnDividerState {
  isActive?: boolean;
}

export interface IAddColumnDividerProps extends IComponentAsProps<IColumnDividerProps> {
  // Nothing yet.
}

export class ColumnDivider extends React.PureComponent<IAddColumnDividerProps, IAddColumnDividerState> {
  constructor(props: IAddColumnDividerProps) {
    super(props);

    this.state = {
      isActive: false
    };
  }

  public render(): JSX.Element {
    const { isActive } = this.state;
    const { defaultRender: DefaultRender, ...columnDividerProps } = this.props;
    const { columnIndex, addIconVisibleForIndex } = columnDividerProps;
    const addIconVisible = addIconVisibleForIndex === columnIndex;
    return (
      <div className={ ColumnDividerStyles.msItemsScopeAddcolumn } key={ `divider-wrapper-${columnIndex}` }>
        <div className={ ColumnDividerStyles.msDetailsHeaderDivider }>
          { DefaultRender && <DefaultRender { ...columnDividerProps } /> }
          <span
            className={ css(ColumnDividerStyles.msDetailsHeaderDividerIcon, {
              [ColumnDividerStyles.msDetailsHeaderDividerIconVisible]: (!!isActive || addIconVisible)
            }) }
          >
            <Icon
              iconName='CircleAdditionSolid'
              data-automationid='msListCustomDividerIcon'
              className={ ColumnDividerStyles.msDetailsHeaderDividerAddIcon }
              onClick={ this._onClickIcon }
            />
            <span
              data-automationid='msListCustomDivider'
              className={ css(ColumnDividerStyles.msDetailsHeaderIconBar, {
                [ColumnDividerStyles.msDetailsHeaderIconBarVisible]: (!!isActive || addIconVisible)
              }) }
            />
          </span>
        </div>
      </div>
    );
  }

  private _onClickIcon = (event: React.MouseEvent<HTMLElement>): void => {
    this.setState({
      isActive: true
    });

    const { engagement, onAddNewColumn, column, columnIndex } = this.props;

    engagement.logData({
      name: 'ColumnDividerIcon.ColumnHeader.Click'
    });

    try {
      onAddNewColumn(event, column, columnIndex);
    } finally {
      this.setState({
        isActive: false
      });
    }
  }
}

export default ColumnDivider;